import { defineStore } from 'pinia';
import client from '../modules/client';

export const manageUserStore = defineStore("manageUser", {
    state: () => ({
        users:[],
        groups:[],
        selectedUser: { 
            name:''
        }
        //validationError: ''
    }),

    actions: {
        async loadUsers(){

            this.users = await client.get(`/sci/managedusers`)
                .then((response) => response.data);
            
        },

        async loadGroups(){

            this.groups = await client.get(`/sci/managedusers/groups`)
                .then((response) => response.data)
        },

        async gethUserById(userId){

            this.selectedUser = {};
            //this.validationError = null;
            
            if(!this.users || this.users.length === 0){
                await this.loadUsers();
                await this.loadGroups();
            }

            if (!(userId > 0)) return;

            this.selectedUser = this.users.find((u) =>  u.id == userId);
        },

        async updateUser(){
            
            const result = await client.post(`/sci/managedusers`, this.selectedUser)
                .catch((error) => {
                    console.error(error)
                    let saveError = 'Error updating the user';
                    if (error.response.status === 400) {
                        //this.validationError = error.response.data.message || error.message;
                        saveError = error.response.data.message || error.message;
                    }
                    throw new Error(saveError);
                });
            
            if (result?.data?.errorMessage) {
                throw new Error(result?.data?.errorMessage);
                //this.validationError = result.data.errorMessage;
                //return false;
            }

            if (result.data.newID) {
                //reset list of user
                this.users = []; 
                //reload user
                await this.gethUserById(result.data.newID);
            }
            
            return true;
        },

        async resetPassword(managedUser){
            //console.log('resetPassword')
            
            const result = await client.post(`/sci/managedusers/resetpassword`, managedUser )
                .catch((error) => {
                    console.error(error)
                    let resetError = 'Error resetting password';
                    if (error.response.status === 400) {
                        resetError = error.response.data.message || error.message;
                    }
                    throw new Error(resetError);
                });

            if (result?.data?.errorMessage) {
                throw new Error(result?.data?.errorMessage);
            }
            
            return true;
        }
    }
});